export enum CourseStatus {
  DONE,
  IN_PROGRESS,
  PARTIAL,
  NEEDED,
}

export type CourseType =
  | 'ARTS'
  | 'SCIENCE'
  | 'HEALTH'
  | 'MATH'
  | 'ELECTIVES'
  | 'LANGUAGE_ARTS'
  | 'PE'
  | 'SOCIAL_STUDIES';

/** @deprecated */
export type Course = {
  Status: CourseStatus;
  IsHonors: boolean;
  CreditEarned: number;
  CourseName: string;
};

/** @deprecated */
export type CourseGroup = {
  CourseGroupCode: CourseType;
  CourseGroupName: string;
  Courses: Course[];
};

/** @deprecated */
export type AcademicOverview = CourseGroup[];

export type CourseCategory = {
  id: number;
  courseName: string;
  creditType: string;
  creditTypeParsed: string;
  credits: number;
  calendarId: number;
  courseCategoryId: number;
};

export type CourseV2 = {
  courseName: string;
  creditsEarned: number;
  isHonors: boolean;
  status: CourseStatus;
  courseSubcategoryEnum: number;
};

export type CourseGroupV2 = {
  courseGroupCode: CourseType;
  courseGroupName: string;
  creditsNeeded: number;
  courses: CourseV2[];
  coursesForList: CourseV2[];
};
